import type { ComponentProps } from "react";
import { LinearGradient } from "@tamagui/linear-gradient";
import { withAlpha } from "@medbillai/utils/color";
import { uiUtilityTokens } from "../../themes/token-colors";
type BrandButtonGradientProps = {
  visible: boolean;
  /** Inline transform style that positions the gradient center at the cursor. */
  style?: ComponentProps<typeof LinearGradient>["style"];
};

// Grellow (green-yellow brand accent) used as the gradient highlight.
// Transparent endpoints let the gradient fade to nothing at its edges.
const grellow = uiUtilityTokens.utilityGrellow;
const transparentGrellow = withAlpha(grellow, 0);

/**
 * Fullscreen gradient overlay shown inside the brand button on hover/press.
 */
export const BrandButtonGradient = ({
  visible,
  style
}: BrandButtonGradientProps) => {
  return <LinearGradient fullscreen aria-hidden={true}
  // Horizontal gradient: transparent → grellow → transparent, centered at 50%.
  colors={[transparentGrellow, grellow, transparentGrellow]} locations={[0, 0.5, 1]} start={{
    x: 0,
    y: 0.5
  }} end={{
    x: 1,
    y: 0.5
  }} opacity={visible ? 1 : 0} pointerEvents="none" //  ensures it doesn't intercept touch/click events.
  style={style} //  applies a CSS transform that centers the gradient on the cursor.
  transition="fade" animateOnly={["opacity"]} data-sentry-element="LinearGradient" data-sentry-component="BrandButtonGradient" data-sentry-source-file="BrandButtonGradient.tsx" />;
};